import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { RoleGuard } from "app/guards";
import { ExportacionesProvider } from "./exportaciones-context";
import { ExportacionesTable } from "./exportaciones-table";
import { ExportacionForm } from "./exportacion-form";

export function ExportacionesRoutes() {
  return (
    <RoleGuard roles={["empresa:exportaciones"]}>
      <ExportacionesProvider>
        <Routes>
          <Route path="/" element={<Outlet />}>
            <Route index element={<ExportacionesTable />} />

            <Route path="add" element={<ExportacionForm />} />

            <Route path=":exportacion_id" element={<Outlet />}>
              <Route index element={<Navigate to="edit" replace />} />

              <Route path="edit" element={<ExportacionForm />} />
            </Route>

            <Route path="*" element="Exportaciones: Page Not Found" />
          </Route>
        </Routes>
      </ExportacionesProvider>
    </RoleGuard>
  );
}
